import { render, staticRenderFns } from "./Power.vue?vue&type=template&id=4ec57f85&scoped=true&"
import script from "./Power.vue?vue&type=script&lang=js&"
export * from "./Power.vue?vue&type=script&lang=js&"
import style0 from "./Power.vue?vue&type=style&index=0&id=4ec57f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec57f85",
  null
  
)

export default component.exports